import React from 'react';
import { applyTypography } from '@repo/common';
import { ReactComponent as CheckCircleIcon } from '@repo/common/assets/icons/24px/icon_24px_check-circle_filled.svg';
import { BOOKING_STEPS } from '../utils/constants';

/**
 * Step Indicator 컴포넌트
 * 예약 플로우(장바구니 → 워크샵 확인 → 결제)의 진행 단계를 표시
 *
 * @param {number} currentStep - 현재 단계 (1, 2, 또는 3)
 * @param {string} className - 추가 CSS 클래스
 */
const StepIndicator = ({ currentStep, className = '' }) => {
  return (
    <div className={`relative flex shrink-0 items-center ${className}`}>
      {BOOKING_STEPS.map((step, index) => {
        const isDone = currentStep > step;
        const isActive = currentStep === step;

        return (
          <React.Fragment key={step}>
            {isDone ? (
              // 완료: 초록색 체크 서클
              <CheckCircleIcon className='size-[24px] shrink-0 text-green-deep01' />
            ) : isActive ? (
              // 진행 중: 옅은 초록 후광 + 초록 원 + 흰색 숫자
              <div className='flex shrink-0 items-center justify-center rounded-full bg-[rgba(0,158,79,0.1)] p-[3px]'>
                <div className='flex size-[20px] items-center justify-center rounded-full bg-green-deep01'>
                  <p
                    className={`${applyTypography('b13Strong')} text-text-inverse`}
                  >
                    {step}
                  </p>
                </div>
              </div>
            ) : (
              // 예정: 회색 원 + 흰색 숫자
              <div className='flex size-[20px] shrink-0 items-center justify-center rounded-full bg-grayscale-gray02'>
                <p
                  className={`${applyTypography('b13Strong')} text-text-inverse`}
                >
                  {step}
                </p>
              </div>
            )}

            {index < BOOKING_STEPS.length - 1 && (
              <div className='flex h-[26px] w-[24px] shrink-0 items-center'>
                <div
                  className={`w-full border-t-2 ${
                    isDone
                      ? 'border-solid border-green-deep01'
                      : 'border-dashed border-grayscale-gray03'
                  }`}
                />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepIndicator;
